/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { Form as FormUi, Container, TextArea, Button, Input, Segment, Dropdown, Icon, Search, Divider, Grid, Header, ButtonGroup, } from "semantic-ui-react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { min, isEmpty } from "lodash";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import MandatoryMark from "../common/mandatorymark";
import { DateData } from "../dynamicComponent/datepick";

const OrderDeatils = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  shipmentEdit,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  props
}) => {
 const [editMode, setEditMode] = useState(false);

   useEffect(() => {
  }, [editMode])


  return (
    <React.Fragment>
      <React.Fragment>
        {/* <h2>Order details</h2>
    <h4>EDIT button</h4>

    form */}

        <Segment className="mt-100">
          <div>
            <Header as='h3' className="heading-01" content='Order Details' textAlign='left' />

            <div className="header-btn">
            <Button size="mini" color="green" icon inverted labelPosition='left' onClick={(e) => { e.preventDefault(); e.stopPropagation(); setEditMode(!editMode) }}>
              <Icon name='edit' />
              Edit
            </Button>
            {editMode ?
            <Button.Group size="mini">
              <Button>Cancel</Button>
              <Button.Or />
              <Button positive>Save</Button>
            </Button.Group>
            :''}
            </div></div>
          <Divider clearing />
          <Formiker>
            <FormUi.Field>
              <Grid container columns={4} stackable>

                <Grid.Column>
                  <label>Order Number: </label>
                </Grid.Column>
                <Grid.Column>
                {editMode ?
                  <Input fluid Field placeholder='DH12563' />
                  :
                  'DH12563'}
                </Grid.Column>

                <Grid.Column>
                  <label>Weight(in Kg)*: </label>
                </Grid.Column>

                <Grid.Column>
                {editMode ?
                  <Input fluid Field placeholder='500' />
                  :
                  '500'}
                </Grid.Column>

                <Grid.Column>
                  <label>Ownership Type: </label>
                </Grid.Column>

                <Grid.Column>
                {/* <Select fluid Dropdown placeholder='Market' /> */}
                {editMode ?
                <Dropdown
                              name="Market"
                              clearable
                              search
                              style={{ width: "100%" }}
                              selection
                              placeholder={""}
                              options={[
                                { key: "3", text: "Primary", value: "primary" },
                                { key: "2", text: "Import", value: "import" },
                                { key: "4", text: "Export", value: "export" },
                              ]}

                            />
                            :
                            'Primary'}
                </Grid.Column>


                <Grid.Column>
                  
                </Grid.Column>

                <Grid.Column>
                  
                </Grid.Column>

                <Grid.Column>
                  <label>Vendor: </label>
                </Grid.Column>

                <Grid.Column>
                {editMode ?
                <Dropdown
                              name="Vendor"
                              clearable
                              search
                              style={{ width: "100%" }}
                              selection
                              placeholder={""}
                              options={[
                                { key: "3", text: "Primary", value: "primary" },
                                { key: "2", text: "Import", value: "import" },
                                { key: "4", text: "Export", value: "export" },
                              ]}

                            />
                            :
                            'Primary'}
                </Grid.Column>

                <Grid.Column>
                  <label>Required Vechicle Type: </label>
                </Grid.Column>
                <Grid.Column>
                {editMode ?
                  <Input fluid Field placeholder='32 Feet' />
                  :
                '32 Feet'}
                </Grid.Column>
              </Grid>


            </FormUi.Field>



          </Formiker>

        </Segment>
      </React.Fragment>
    </React.Fragment>
  );
};

const FormikShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
  }),
  // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
  mapPropsToValues: (props) => (
    {
      //movement_type: (props.shipmentEdit ? props.shipmentEdit.movement_type : localStorage.getItem("customerNumber") != 1122 ? "primary" : "import"),
    }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {

  },
})(OrderDeatils);

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_shipment")(FormikShipment));
